// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__380c0","rightAdornment":"Header_rightAdornment__1_xcJ"};